var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#079d7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01795e"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v11.428571h-16z",
    fill: "url(#c)",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.571429 1.52381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.86806133 5.2588936c.10901158.02895609.21673618.05374098.3223135.07443985l-1.80942245-.00000012c.09036574.2712602.21199247.52685271.36028751.76190477h5.37466307c.14829504-.23505206.26992178-.49064457.36028752-.76190477h-1.83410447c.10888257-.02024915.2202113-.0448841.33302517-.07400003-.34583612.01149128-.90968868.07400003-1.54653975.07400003-.64550074 0-1.21600658-.06421826-1.5605101-.07443973zm-.3176856-.09558356c-.85390256-.288264-1.43912749-.75060858-1.34713383-1.09393361.10264802-.38308763 1.00959349-.47292297 2.0257194-.20065285.05335145.01429548.10594313.02930496.15769287.04496951-.02300035-.15488495-.03524854-.31747399-.03524854-.48512166 0-1.05197095.48226355-1.90476191 1.0771658-1.90476191s1.0771658.85279096 1.0771658 1.90476191c0 .16677655-.01212124.32854692-.03489088.48270664.0584296-.0179625.11795617-.0350927.17845987-.05130461 1.01612592-.27227012 1.92307138-.18243478 2.0257194.20065285.09276835.3462162-.5031358.81346497-1.36876319 1.10117892-.1529242-.45353032-.93540216-.59037666-1.877691-.59037666-.9433302 0-1.72649612.13714898-1.8781957.59188147zm3.90949139 1.69383282c-.55500111.47649519-1.26173375.76190476-2.03129569.76190476s-1.47629458-.28540957-2.03129569-.76190476z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.42857143.76190476c-.21039419 0-.38095238-.17055819-.38095238-.38095238s.17055819-.38095238.38095238-.38095238.38095238.17055819.38095238.38095238-.17055819.38095238-.38095238.38095238zm-3.04761905 1.90476191c-.21039419 0-.38095238-.1705582-.38095238-.38095238 0-.21039419.17055819-.38095239.38095238-.38095239s.38095238.1705582.38095238.38095239c0 .21039418-.17055819.38095238-.38095238.38095238zm6.0952381 0c-.21039419 0-.38095238-.1705582-.38095238-.38095238 0-.21039419.17055819-.38095239.38095238-.38095239.21039418 0 .38095238.1705582.38095238.38095239 0 .21039418-.1705582.38095238-.38095238.38095238zm-1.14285715-1.14285715c-.21039418 0-.38095238-.17055819-.38095238-.38095238 0-.21039418.1705582-.38095238.38095238-.38095238.21039419 0 .38095238.1705582.38095238.38095238 0 .21039419-.17055819.38095238-.38095238.38095238zm-3.80952381 0c-.21039418 0-.38095238-.17055819-.38095238-.38095238 0-.21039418.1705582-.38095238.38095238-.38095238.21039419 0 .38095238.1705582.38095238.38095238 0 .21039419-.17055819.38095238-.38095238.38095238z",
    fill: "#fcd117"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMo);
export default __webpack_public_path__ + "static/media/MO.8b225d2a20a6c9896faa7d7fb3a50d4e.svg";
export { ForwardRef as ReactComponent };